import { Download, GridCell } from '@uhg-uicl/ui-core/dist';

export const INVOICING_EMPTY_GRID_RECORD_MESSAGE = 'No records to display at this time.';
export const CREATE_INVOICES_EMPTY_GRID_MESSAGE = 'No records to display at this time.';

export const VIEW_GRID_COLUMNS = new Set([
  {
    dataName: 'download',
    text: <GridCell cellType="icon" data={{ icon: Download }} />,
    align: 'left',
    cellType: 'custom',
    isHeaderTruncated: true,
    headerWidth: 40,
    sortable: false,
  },
  {
    dataName: 'name',
    text: 'Name',
    isHeaderTruncated: true,
    headerWidth: 500,
    sortable: false,
  },
  {
    dataName: 'lastModifiedDate',
    text: 'Last Modified',
    sortable: false,
    isSorted: 1,
    isHeaderTruncated: true,
    headerWidth: 160,
  },
  {
    dataName: 'size',
    text: 'Size',
    isHeaderTruncated: true,
    headerWidth: 90,
    sortable: false,
  },
]);

export const VIEW_CREATE_INVOICES_COLUMNS = new Set([
  {
    dataName: 'clientPartnerId',
    text: 'Client Partner ID',
    sortable: true
  },
  {
    dataName: 'companyName',
    text: 'Company Name',
    sortable: true
  },
  { 
    dataName: 'invoicesInceptionToDate',
    text: 'Invoices (Inception-To-Date)',
    sortable: true
  },
]);

export const VIEW_INVOICE_MODAL_COLUMNS = new Set([
    {
        dataName: 'clientPartnerId',
        text: 'Client Partner ID',
        sortable: false,
        isSorted: 0,
    },
    {
        dataName: 'companyName',
        text: 'Company Name',
        sortable: false,
        isSorted: 0,
    }
]);

export enum ActionTypesInvoicings {
  SET_INVOICING_DIRECTORY_LIST = 'SET_INVOICING_DIRECTORY_LIST',
  SET_CURRENT_INVOICING_DIRECTORY = 'SET_CURRENT_INVOICING_DIRECTORY',
  SET_INVOICING_DATA = 'SET_INVOICING_DATA',
  SET_INVOICING_TOTAL_FILES = 'SET_INVOICING_TOTAL_FILES',
  TOGGLE_IS_INVOICING_DIRECTORY_LIST_LOADING = 'TOGGLE_IS_INVOICING_DIRECTORY_LIST_LOADING',
  TOGGLE_IS_INVOICING_DATA_LOADING = 'TOGGLE_IS_INVOICING_DATA_LOADING',
  SET_CLIENT_TYPE_INVOICE_DATA = 'SET_CLIENT_TYPE_INVOICE_DATA',
  TOGGLE_IS_CLIENT_TYPE_DATA_LOADING = 'TOGGLE_IS_CLIENT_TYPE_DATA_LOADING',
  TOGGLE_IS_INVOICE_UPLOAD_LOADING = 'TOGGLE_IS_INVOICE_UPLOAD_LOADING',
  TOGGLE_IS_INVOICE_DELETE_LOADING = 'TOGGLE_IS_INVOICE_DELETE_LOADING',
}

export const INVOICE_ENTITY_TYPE_DROPDOWN = [
  {
    label: 'Client',
    value: '1',
  },
  {
    label: 'Partner',
    value: '2',  
  },
  {
    label: 'Referring Client',
    value: '3',  
  },
  {
    label: 'Broker',
    value: '4',  
  }
];

export const GENERATE_INVOICE_MONTHS_DROPDOWN = [
  {
    label: 'January',
    value: '01',
  },
  {
    label: 'February',
    value: '02',  
  },
  {
    label: 'March',
    value: '03',
  },
  {
    label: 'April',
    value: '04',
  },
  {
    label: 'May',
    value: '05',
  },
  {
    label: 'June',
    value: '06',
  },
  {
    label: 'July',
    value: '07',
  },
  {
    label: 'August',
    value: '08',
  },
  {
    label: 'September',
    value: '09',
  },
  {
    label: 'October',
    value: '10',
  },
  {
    label: 'November',
    value: '11',
  },
  {
    label: 'December',
    value: '12',
  },
]

export const GENERATE_INVOICE_YEARS_DROPDOWN = (() => {
  const currentYear = new Date().getFullYear();
  const startYear = 2004;
  const endYear = currentYear + 1;
  const years: { label: string; value: string }[] = [];
  
  for (let year = endYear; year >= startYear; year--) {
    years.push({
      label: year.toString(),
      value: year.toString(),
    });
  }
  
  return years;
})();